// next
import NextLink from 'next/link';
// @mui
import {
  Stack,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
// hooks
import useAuth from '../../hooks/useAuth';
// routes
import { PATH_SCOUT } from '../../routes/paths';

// ----------------------------------------------------------------------

const hideScrollbar = {
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  overflowX: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

export default function ScoutTabs({ tab }) {
  const { user } = useAuth();
  const plan = user?.employee?.company?.[0]?.scout_plan;

  return (
    <Stack direction="row" spacing={{ xs: 2, sm: 4 }} sx={{ ...hideScrollbar, py: 2 }}>
      <NextLink href={`${PATH_SCOUT.root}`}>
        <TabItemStyle isActive={tab === 'recommend'}>
          {plan === "enterprise" ? "전체 인재풀" : "추천"}
        </TabItemStyle>
      </NextLink>
      <NextLink href={`${PATH_SCOUT.manage}`}>
        <TabItemStyle isActive={tab === 'manage'}>
          내 인재풀
        </TabItemStyle>
      </NextLink>
      <NextLink href={`${PATH_SCOUT.profile}`}>
        <TabItemStyle isActive={tab === 'profile'}>
          회사 소개
        </TabItemStyle>
      </NextLink>
    </Stack>
  )
}

const TabItemStyle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})(({ theme, isActive }) => {
  return {
    ...theme.typography.h4,
    color: theme.palette.text.disabled,
    '&:hover': {
      cursor: 'pointer',
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
    },
    ...(isActive && {
      color: theme.palette.text.primary,
    })
  }
});